<p>
    {{ "authenticating" | translate }}
</p>